module.exports = __webpack_public_path__ + "img/img-jili.6116d4ac.png";